import Notification from "../../../global/js/Utils/ToasterNotification";

export default class AnyPage {

    main() {
        this.initialCopyButtons();
        this.initFixedHeader();
        // this.initSearchRecommendations()
        // this.initProductSliderResponsive()
        // this.initCategorySlider()
        // this.initProductSlider()
        // this.initProductGallerySlider()
        // this.initSuggestionProductSlider()
        this.initSideBarStickySlider()
        this.initToggleMoreProductParams()
        // this.initHorizontalTabs()
        this.initSelectListBox()
        this.initBackToTopButton()
        this.initResponsiveHeader()
        this.initFavoritesProduct()
        this.initTabable()
    }

    initialCopyButtons() {
        new ClipboardJS('[data-clipboard=true]').on('success', function (e) {
            e.clearSelection();
            Notification.setOptions('success', 3, 'کپی شد!!');
        });
    }

    initFixedHeader() {
        $(window).scroll(function () {
            if ($(this).scrollTop() > 130) {
                $('header.main-header.js-fixed-header').addClass('fixed');
                $('header.main-header.js-fixed-topbar').addClass('fixed fixed-topbar');
            } else {
                $('header.main-header.js-fixed-header').removeClass('fixed');
                $('header.main-header.js-fixed-topbar').removeClass('fixed fixed-topbar');
            }
        });
    }

    initSearchRecommendations() {
        $("header.main-header .search-area form.search input").keyup(function () {
            if ($(this).val().length === 0) {
                // Hide the element
                $("header.main-header .search-area form.search .search-result").removeClass('open');
                $("header.main-header .search-area form.search .close-search-result").removeClass('show');
            } else {
                // Otherwise show it
                $("header.main-header .search-area form.search .search-result").addClass('open');
                $("header.main-header .search-area form.search .close-search-result").addClass('show');
            }
        });
        $("header.main-header .search-area form.search .close-search-result").on('click', function () {
            $(this).removeClass('show');
            $("header.main-header .search-area form.search .search-result").removeClass('open');
        });
    }

    initCategorySlider() {
        $(".category-slider").owlCarousel({
            rtl: true,
            margin: 10,
            nav: true,
            navText: ['<i class="mdi mdi mdi-chevron-right"></i>', '<i class="mdi mdi mdi-chevron-left"></i>'],
            dots: false,
            responsiveClass: true,
            responsive: {
                0: {
                    items: 2,
                    slideBy: 1
                },
                576: {
                    items: 3,
                    slideBy: 2
                },
                768: {
                    items: 4,
                    slideBy: 2
                },
                992: {
                    items: 6,
                    slideBy: 3
                },
                1400: {
                    items: 8,
                    slideBy: 4
                }
            }
        });
    }

    initProductSliderResponsive() {
        $(".carousel-lg").owlCarousel({
            rtl: true,
            margin: 10,
            nav: true,
            navText: ['<i class="fa-solid fa-chevron-right text-secondary font-size-30"></i>', '<i class="fa-solid fa-chevron-left text-secondary font-size-30"></i>'],
            dots: true,
            responsiveClass: true,
            responsive: {
                0: {
                    items: 1,
                    slideBy: 1
                },
                425: {
                    items: 2,
                    slideBy: 1
                },
                576: {
                    items: 3,
                    slideBy: 1
                },
                768: {
                    items: 3,
                    slideBy: 2
                },
                992: {
                    items: 4,
                    slideBy: 2
                },
                1200: {
                    items: 5,
                    slideBy: 3
                },
                1400: {
                    items: 5,
                    slideBy: 4
                }
            }
        });
        $(".carousel-md").owlCarousel({
            rtl: true,
            margin: 10,
            nav: true,
            navText: ['<i class="fa-solid fa-chevron-right text-secondary font-size-30"></i>', '<i class="fa-solid fa-chevron-left text-secondary font-size-30"></i>'],
            dots: true,
            responsiveClass: true,
            responsive: {
                0: {
                    items: 1,
                    slideBy: 1
                },
                425: {
                    items: 2,
                    slideBy: 1
                },
                576: {
                    items: 3,
                    slideBy: 1
                },
                768: {
                    items: 3,
                    slideBy: 2
                },
                992: {
                    items: 4,
                    slideBy: 2
                },
                1200: {
                    items: 4,
                    slideBy: 3
                },
                1400: {
                    items: 4,
                    slideBy: 3
                }
            }
        });
    }

    initSuggestionProductSlider() {
        $("#suggestion-slider").owlCarousel({
            rtl: true,
            items: 1,
            autoplay: true,
            autoplayTimeout: 5000,
            loop: true,
            dots: false,
            mouseDrag: false,
            touchDrag: false,
            pullDrag: false,
            freeDrag: false,
            onInitialized: startProgressBar,
            onTranslate: resetProgressBar,
            onTranslated: startProgressBar
        });

        function startProgressBar() {
            // apply keyframe animation
            $(".slide-progress").css({
                width: "100%",
                transition: "width 5000ms"
            });
        }

        function resetProgressBar() {
            $(".slide-progress").css({
                width: 0,
                transition: "width 0s"
            });
        }
    }

    initTabable() {
        $(document).on('mousedown', '.tabable .tab-item', function () {
            if ($(this).hasClass('active')) {
                return;
            }

            const container = $(this).closest('.tabable')
            container.find('.tab-item').removeClass('active')
            $(this).addClass('active')
        })
    }

    initProductGallerySlider() {
        $(".product-gallery-carousel").owlCarousel({
            rtl: true,
            items: 1,
            loop: false,
            dots: false,
            nav: true,
            navText: ['<i class="fa-solid fa-chevron-right text-secondary font-size-30"></i>', '<i class="fa-solid fa-chevron-left text-secondary font-size-30"></i>'],
            URLhashListener: true,
            startPosition: "URLHash",
            onTranslate: function (t) {
                const a = t.item.index,
                    e = $(".owl-item").eq(a).find("[data-hash]").attr("data-hash");
                $(".product-thumbnails li").removeClass("active"),
                    $('[href="#' + e + '"]').parent().addClass("active"),
                    $('[data-hash="' + e + '"]').parent().addClass("active")
            },
        });
    }

    initSideBarStickySlider() {
        let sidebar;
        if ((sidebar = $('.container .sticky-sidebar')).length) {
            sidebar.theiaStickySidebar();
        }
    }

    initToggleMoreProductParams() {
        $(".product-params .sum-more").click(function () {
            var sumaryBox = $(this).parents('.product-params');
            sumaryBox.toggleClass('active');

            $(this).find('i').toggleClass('active');

            $(this).find('.show-more').fadeToggle(0);
            $(this).find('.show-less').fadeToggle(0);

        });
    }

    initHorizontalTabs() {
        $('.ah-tab-wrapper').horizontalmenu({
            itemClick: function (item) {
                $('.ah-tab-content-wrapper .ah-tab-content').removeAttr('data-ah-tab-active');
                $('.ah-tab-content-wrapper .ah-tab-content:eq(' + $(item).index() + ')').attr('data-ah-tab-active', 'true');
                return false; //if this finction return true then will be executed http request
            }
        });
    }

    initSelectListBox() {
        if ($('.custom-select-ui').length) {
            $('.custom-select-ui select').niceSelect();
        }
    }

    initBackToTopButton() {
        $(document).on('click', '.back-to-top', function () {
            $(document).find('body, html').animate({
                scrollTop: 0
            }, 500);
            return false;
        });
    }

    initResponsiveHeader() {
        $(document).on('click', 'header.main-header button.btn-menu', function () {
            $('header.main-header .side-menu').addClass('open');
            $('header.main-header .overlay-side-menu').addClass('show');
        });
        $('header.main-header .overlay-side-menu.show').click(function () {
            $(this).removeClass('show');
            $('header.main-header .side-menu').removeClass('open');
        });
        $(document).on('click', 'button.btn-menu', function () {
            $('.overlay-side-menu').fadeIn(200);
            $('header.main-header .side-menu').addClass("open");
        });

        $(document).on('click', '.overlay-side-menu', function () {
            let side_menu;
            if ((side_menu = $('header.main-header .side-menu')).hasClass('open')) {
                side_menu.removeClass('open');
            }
            $(this).fadeOut(200);
        });
        $('header.main-header .side-menu li.active').addClass('open').children('ul').show();
        $("header.main-header .side-menu li.sub-menu> a").on('click', function () {
            $(this).removeAttr('href');
            var e = $(this).parent('li');
            if (e.hasClass('open')) {
                e.removeClass('open');
                e.find('li').removeClass('open');
                e.find('ul').slideUp(400);

            } else {
                e.addClass('open');
                e.children('ul').slideDown(400);
                e.siblings('li').children('ul').slideUp(400);
                e.siblings('li').removeClass('open');
            }
        });
    }

    initFavoritesProduct() {
        $("ul.gallery-options button.add-favorites").on("click", function () {
            $(this).toggleClass("favorites");
        });
    }
}